import WebformsTypes from './webforms.types';

export const loadWebforms = forms => ({
	type: WebformsTypes.LOAD_WEBFORMS,
	payload: forms
});
